/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Contact } from '../models/Contact';
import type { Email } from '../models/Email';
import type { Facility } from '../models/Facility';
import type { FacilityContact } from '../models/FacilityContact';
import type { FacilityContactCreate } from '../models/FacilityContactCreate';
import type { FacilityContactUpdate } from '../models/FacilityContactUpdate';
import type { FacilityCreate } from '../models/FacilityCreate';
import type { FacilitySpecialty } from '../models/FacilitySpecialty';
import type { FacilitySpecialtyWrite } from '../models/FacilitySpecialtyWrite';
import type { IdentifyHealthcareUserResponse } from '../models/IdentifyHealthcareUserResponse';
import type { PaginatedContactList } from '../models/PaginatedContactList';
import type { PaginatedFacilityContactList } from '../models/PaginatedFacilityContactList';
import type { PaginatedFacilityListList } from '../models/PaginatedFacilityListList';
import type { PaginatedFacilitySpecialtyList } from '../models/PaginatedFacilitySpecialtyList';
import type { PaginatedFacilityTypeFieldsList } from '../models/PaginatedFacilityTypeFieldsList';
import type { PatchedContact } from '../models/PatchedContact';
import type { PatchedFacility } from '../models/PatchedFacility';
import type { PatchedFacilityContactUpdate } from '../models/PatchedFacilityContactUpdate';
import type { PatchedFacilitySpecialtyWrite } from '../models/PatchedFacilitySpecialtyWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HealthcareEntitiesService {

    /**
     * @returns PaginatedContactList
     * @throws ApiError
     */
    public static healthcareEntitiesContactsList({
        email,
        excludeFacility,
        excludeRole,
        firstName,
        healthcareEntity,
        lastName,
        limit,
        offset,
        ordering,
    }: {
        email?: string,
        excludeFacility?: string,
        /**
         * * `MEDICAL_DIRECTOR` - Medical Director
         * * `ASSISTANT_MEDICAL_DIRECTOR` - Assistant Medical Director
         * * `CLINICAL_DIRECTOR` - Clinical Director
         * * `ONBOARDING` - Onboarding
         * * `PLACEMENT_LEAD` - Placement Lead
         * * `SCHEDULER` - Scheduler
         */
        excludeRole?: 'ASSISTANT_MEDICAL_DIRECTOR' | 'CLINICAL_DIRECTOR' | 'MEDICAL_DIRECTOR' | 'ONBOARDING' | 'PLACEMENT_LEAD' | 'SCHEDULER',
        firstName?: string,
        healthcareEntity?: string,
        lastName?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
    }): CancelablePromise<PaginatedContactList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/contacts/',
            query: {
                'email': email,
                'exclude_facility': excludeFacility,
                'exclude_role': excludeRole,
                'first_name': firstName,
                'healthcare_entity': healthcareEntity,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
            },
        });
    }

    /**
     * @returns Contact
     * @throws ApiError
     */
    public static healthcareEntitiesContactsCreate({
        requestBody,
    }: {
        requestBody?: Contact,
    }): CancelablePromise<Contact> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare-entities/contacts/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Contact
     * @throws ApiError
     */
    public static healthcareEntitiesContactsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this HCO Contact.
         */
        id: string,
    }): CancelablePromise<Contact> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/contacts/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Contact
     * @throws ApiError
     */
    public static healthcareEntitiesContactsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this HCO Contact.
         */
        id: string,
        requestBody?: Contact,
    }): CancelablePromise<Contact> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare-entities/contacts/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Contact
     * @throws ApiError
     */
    public static healthcareEntitiesContactsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this HCO Contact.
         */
        id: string,
        requestBody?: PatchedContact,
    }): CancelablePromise<Contact> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare-entities/contacts/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static healthcareEntitiesContactsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this HCO Contact.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/healthcare-entities/contacts/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * List healthcare facilities. Returns a subset of facility fields for lists. Only accessible by healthcare organization users.
     * @returns PaginatedFacilityListList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitiesList({
        city,
        emr,
        facilityType,
        healthcareEntity,
        hospitalOwnership,
        limit,
        name,
        notProvider,
        offset,
        ordering,
        provider,
        search,
        state,
    }: {
        city?: string,
        emr?: string,
        facilityType?: string,
        healthcareEntity?: string,
        hospitalOwnership?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: string,
        notProvider?: string,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * A search term.
         */
        search?: string,
        state?: string,
    }): CancelablePromise<PaginatedFacilityListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facilities/',
            query: {
                'city': city,
                'emr': emr,
                'facility_type': facilityType,
                'healthcare_entity': healthcareEntity,
                'hospital_ownership': hospitalOwnership,
                'limit': limit,
                'name': name,
                'not_provider': notProvider,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'search': search,
                'state': state,
            },
        });
    }

    /**
     * Create a new healthcare facility. Only accessible by healthcare organization users with `manage_facilities` permission.
     * @returns Facility
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitiesCreate({
        requestBody,
    }: {
        requestBody: FacilityCreate,
    }): CancelablePromise<Facility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare-entities/facilities/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieve a healthcare facility's details. Only accessible by healthcare organization users.
     * @returns Facility
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitiesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Healthcare Facility.
         */
        id: string,
    }): CancelablePromise<Facility> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facilities/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a healthcare facility. Only accessible by healthcare organization users with `manage_facilities` permission.
     * @returns Facility
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Healthcare Facility.
         */
        id: string,
        requestBody: Facility,
    }): CancelablePromise<Facility> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare-entities/facilities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Facility
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Healthcare Facility.
         */
        id: string,
        requestBody?: PatchedFacility,
    }): CancelablePromise<Facility> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare-entities/facilities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitiesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Healthcare Facility.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/healthcare-entities/facilities/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * List healthcare facility contacts. Returns a subset of facility fields for lists. Only accessible by healthcare organization users.
     * @returns PaginatedFacilityContactList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsList({
        email,
        facility,
        firstName,
        lastName,
        limit,
        offset,
        ordering,
        role,
    }: {
        email?: string,
        facility?: string,
        firstName?: string,
        lastName?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        role?: string,
    }): CancelablePromise<PaginatedFacilityContactList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facility-contacts/',
            query: {
                'email': email,
                'facility': facility,
                'first_name': firstName,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'role': role,
            },
        });
    }

    /**
     *
     * Creates one or multiple facility contacts.
     * - For single contact creation, provide a single object
     * - For bulk creation, provide an array of objects
     * Returns the created contact(s) in the same format as the request (single object or array)
     *
     * @returns FacilityContact
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsCreate({
        requestBody,
    }: {
        requestBody: FacilityContactCreate,
    }): CancelablePromise<FacilityContact> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare-entities/facility-contacts/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieve a healthcare facility contact's details. Only accessible by healthcare organization users.
     * @returns FacilityContact
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Facility Contact.
         */
        id: string,
    }): CancelablePromise<FacilityContact> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facility-contacts/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a healthcare facility contact. Only accessible by healthcare organization users with `manage_facilities` permission.
     * @returns FacilityContact
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Facility Contact.
         */
        id: string,
        requestBody: FacilityContactUpdate,
    }): CancelablePromise<FacilityContact> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare-entities/facility-contacts/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns FacilityContactUpdate
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Facility Contact.
         */
        id: string,
        requestBody?: PatchedFacilityContactUpdate,
    }): CancelablePromise<FacilityContactUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare-entities/facility-contacts/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Facility Contact.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/healthcare-entities/facility-contacts/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns FacilityContact
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsCreateBulkCreate({
        requestBody,
    }: {
        requestBody: FacilityContactCreate,
    }): CancelablePromise<FacilityContact> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare-entities/facility-contacts/create-bulk/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedFacilityContactList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsUpdateBulkUpdate({
        requestBody,
        email,
        facility,
        firstName,
        lastName,
        limit,
        offset,
        ordering,
        role,
    }: {
        requestBody: FacilityContactUpdate,
        email?: string,
        facility?: string,
        firstName?: string,
        lastName?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        role?: string,
    }): CancelablePromise<PaginatedFacilityContactList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare-entities/facility-contacts/update-bulk/',
            query: {
                'email': email,
                'facility': facility,
                'first_name': firstName,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'role': role,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedFacilityContactList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityContactsUpdateBulkPartialUpdate({
        email,
        facility,
        firstName,
        lastName,
        limit,
        offset,
        ordering,
        role,
        requestBody,
    }: {
        email?: string,
        facility?: string,
        firstName?: string,
        lastName?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        role?: string,
        requestBody?: PatchedFacilityContactUpdate,
    }): CancelablePromise<PaginatedFacilityContactList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare-entities/facility-contacts/update-bulk/',
            query: {
                'email': email,
                'facility': facility,
                'first_name': firstName,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'role': role,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedFacilitySpecialtyList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesList({
        facility,
        limit,
        offset,
    }: {
        facility?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedFacilitySpecialtyList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facility-specialties/',
            query: {
                'facility': facility,
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns PaginatedFacilitySpecialtyList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesCreate({
        requestBody,
        facility,
        limit,
        offset,
    }: {
        requestBody: FacilitySpecialtyWrite,
        facility?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedFacilitySpecialtyList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare-entities/facility-specialties/',
            query: {
                'facility': facility,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns FacilitySpecialty
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Facility Specialty.
         */
        id: string,
    }): CancelablePromise<FacilitySpecialty> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facility-specialties/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns FacilitySpecialty
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Facility Specialty.
         */
        id: string,
        requestBody: FacilitySpecialtyWrite,
    }): CancelablePromise<FacilitySpecialty> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare-entities/facility-specialties/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns FacilitySpecialtyWrite
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Facility Specialty.
         */
        id: string,
        requestBody?: PatchedFacilitySpecialtyWrite,
    }): CancelablePromise<FacilitySpecialtyWrite> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare-entities/facility-specialties/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Facility Specialty.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/healthcare-entities/facility-specialties/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns PaginatedFacilitySpecialtyList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesUpdateBulkUpdate({
        requestBody,
        facility,
        limit,
        offset,
    }: {
        requestBody: FacilitySpecialtyWrite,
        facility?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedFacilitySpecialtyList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare-entities/facility-specialties/update-bulk/',
            query: {
                'facility': facility,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedFacilitySpecialtyList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilitySpecialtiesUpdateBulkPartialUpdate({
        facility,
        limit,
        offset,
        requestBody,
    }: {
        facility?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        requestBody?: PatchedFacilitySpecialtyWrite,
    }): CancelablePromise<PaginatedFacilitySpecialtyList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare-entities/facility-specialties/update-bulk/',
            query: {
                'facility': facility,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedFacilityTypeFieldsList
     * @throws ApiError
     */
    public static healthcareEntitiesFacilityTypeFieldsList({
        facilityType,
        limit,
        offset,
    }: {
        /**
         * * `ACUTE_CARE_HOSPITAL` - Acute Care Hospital
         * * `ASC` - ASC
         * * `BEHAVIORAL_HEALTH_HOSPITAL` - Behavioral Health Hospital
         * * `CLINIC` - Clinic
         * * `CRITICAL_ACCESS_HOSPITAL` - Critical Access Hospital
         * * `FREE_STANDING_ER` - Free-standing ER
         * * `LTAC` - LTAC
         * * `REHAB` - Rehab
         * * `SNF` - SNF
         * * `TELEHEALTH` - Telehealth
         * * `URGENT CARE` - Urgent Care
         * * `OTHER` - other
         */
        facilityType?: 'ACUTE_CARE_HOSPITAL' | 'ASC' | 'BEHAVIORAL_HEALTH_HOSPITAL' | 'CLINIC' | 'CRITICAL_ACCESS_HOSPITAL' | 'FREE_STANDING_ER' | 'LTAC' | 'OTHER' | 'REHAB' | 'SNF' | 'TELEHEALTH' | 'URGENT CARE',
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedFacilityTypeFieldsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare-entities/facility-type-fields/',
            query: {
                'facility_type': facilityType,
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns IdentifyHealthcareUserResponse
     * @throws ApiError
     */
    public static healthcareEntitiesIdentifyHealthcareUserCreate({
        requestBody,
    }: {
        requestBody: Email,
    }): CancelablePromise<IdentifyHealthcareUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare-entities/identify-healthcare-user/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
